<template>
	<div class="statistics">
		<span v-for="(statistic, index) in statistics" :key="index">
			<span>{{ statistic.name }}</span>
			<span>{{ statistic.value }}</span>
		</span>
	</div>
</template>

<script>
export default {
	name: 'graph-stats',

	props: {
		/**
		 * @prop 	statistics
		 * @type 	Array
		 * @desc	Array of name and values pair object containing records of stats like max, min, avrg values
		 * @required
		 */
		statistics: {
			type: Array
		}
	}
}
</script>

<style lang="scss" scoped>
.statistics {
	position: absolute;
	width: 300px;
	z-index: 1001;
	right: 0px;
	top: -20px;
	text-align: right;
	padding-top: 12px;

	> * {
		display: inline-block;
		margin-right: 20px;

		span {
			display: block;
			text-align: center;
		}

		span:first-child {
			font-size: 12px;
			color: #7f7f7f;
		}

		span:last-child {
			font-size: 14px;
			font-weight: 700;
		}
	}
}
</style>
